// RouteTracker.jsx
import { createContext, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const PreviousRouteContext = createContext(null);

export const PreviousRouteProvider = ({ children }) => {
  const location = useLocation();
  const prevPath = useRef(null);

  useEffect(() => {
    // When route changes, update previous path

    let previousPath =  sessionStorage.getItem("previousRoute") ? sessionStorage.getItem("previousRoute") : null
   
    const current = location.pathname;

    // console.log("current path-->", current)
  
    if(current === "/" || current === "/home"){
        sessionStorage.setItem("previousRoute", previousPath);
    }else{
        sessionStorage.setItem("previousRoute", location.pathname);
    }
    

    return () => {
      prevPath.current = current;
    };
  }, [location]);

  return (
    <PreviousRouteContext.Provider value={prevPath.current}>
      {children}
    </PreviousRouteContext.Provider>
  );
};

export const usePreviousRoute = () => useContext(PreviousRouteContext);
